module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/90a50cdcc7b6b7a38be8de7e4dc24237.png";